// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-viewer {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #1a1a1a;
    border-radius: 8px;
    overflow: hidden;
}

.slide-viewer__canvas-wrapper {
    position: relative;
    width: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: #2a2a2a;
}

.slide-viewer__overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    color: #ccc;
    font-size: 14px;
    text-align: center;
}

.slide-viewer__overlay--error {
    color: #f66;
}

.slide-viewer__canvas {
    display: block;
    max-width: 100%;
}

.slide-viewer__controls {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 24px;
    background: #1a1a1a;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
}

.slide-viewer__btn {
    background: #3a3a3a;
    color: #fff;
    border: none;
    border-radius: 4px;
    width: 36px;
    height: 36px;
    font-size: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.slide-viewer__btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.slide-viewer__btn:not(:disabled):hover {
    background: #555;
}

.slide-viewer__page-info {
    color: #ccc;
    font-size: 14px;
    min-width: 64px;
    text-align: center;
}

.slide-viewer__loading,
.slide-viewer__error {
    padding: 40px;
    color: #ccc;
    font-size: 14px;
}

.slide-viewer__error {
    color: #f66;
}
`, "",{"version":3,"sources":["webpack://./react/features/slide-view/components/web/slide-viewer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".slide-viewer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: #1a1a1a;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.slide-viewer__canvas-wrapper {\n    position: relative;\n    width: 100%;\n    overflow: auto;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    background: #2a2a2a;\n}\n\n.slide-viewer__overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: 40px;\n    color: #ccc;\n    font-size: 14px;\n    text-align: center;\n}\n\n.slide-viewer__overlay--error {\n    color: #f66;\n}\n\n.slide-viewer__canvas {\n    display: block;\n    max-width: 100%;\n}\n\n.slide-viewer__controls {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 12px 24px;\n    background: #1a1a1a;\n    width: 100%;\n    box-sizing: border-box;\n    justify-content: center;\n}\n\n.slide-viewer__btn {\n    background: #3a3a3a;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    width: 36px;\n    height: 36px;\n    font-size: 24px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.slide-viewer__btn:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.slide-viewer__btn:not(:disabled):hover {\n    background: #555;\n}\n\n.slide-viewer__page-info {\n    color: #ccc;\n    font-size: 14px;\n    min-width: 64px;\n    text-align: center;\n}\n\n.slide-viewer__loading,\n.slide-viewer__error {\n    padding: 40px;\n    color: #ccc;\n    font-size: 14px;\n}\n\n.slide-viewer__error {\n    color: #f66;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
